/**
 * Константы режима Краш
 */

// URL crash-сокета задаётся через env (см. .env.development / .env.production)
export const CRASH_WS_URL = import.meta.env.VITE_CRASH_WS_URL || 'https://ws.skinbiz.biz'

// path обязателен: общий игровой сокет обслуживает Crash, Double и X50
export const CRASH_SOCKET_PATH = '/ws/socket.io/'

// Токен для локальной разработки: бэкенд тестового стенда подставляет chat_id=1
// (только при непустом токене — пустой оставляет сокет наблюдателем)
export const CRASH_DEV_TOKEN = 'dev'
// chat_id тестового игрока, которого стенд подставляет при невалидном токене (§1a)
export const CRASH_DEV_CHAT_ID = 1

// Пороги watchdog по тикам (§8.1 краш-документации)
// 100мс — интервал тиков (CRASH_TICK_MS на бэкенде)
export const TICK_TIMEOUT_MS = 500       // ~5 пропущенных тиков → заморозить множитель
export const OFFLINE_NOTICE_MS = 3000   // показать плашку «связь потеряна»

// Таймаут ожидания crash:win-skin, после которого гасим плашку «подбираем предмет»
// страховкой «проверьте инвентарь» (§5a: событие не доехало при обрыве)
export const WIN_SKIN_TIMEOUT_MS = 10000

// Страховка кнопки «Вывести» (§8.5): если crash:cashout не пришёл за это время
// (emit потерялся при разрыве), снимаем блокировку — повторный клик сервер игнорирует
export const CASHOUT_CONFIRM_TIMEOUT_MS = 1500

// Размер ленты последних множителей сверху экрана
export const HISTORY_STRIP_SIZE = 20

// Порог множителя, ниже которого точка краха рисуется красной
export const CRASH_LOW_THRESHOLD = 200   // в сотых: 200 = 2.00×

// Имена событий сервер → клиент
export const SERVER_EVENTS = {
  TIME: 'crash:time',
  ROUND: 'crash:round',
  RUN: 'crash:run',
  TICK: 'crash:tick',
  BUST: 'crash:bust',
  BET: 'crash:bet',            // своя ставка (только тебе)
  BETS: 'crash:bets',          // чужие ставки, пачкой
  CASHOUT: 'crash:cashout',    // твой вывод (только тебе)
  CASHOUTS: 'crash:cashouts',  // чужие выводы, пачкой
  WIN_SKIN: 'crash:win-skin',
  INVENTORY: 'crash:inventory',
  PLAYERS: 'crash:players',
  HISTORY: 'crash:history',
  BALANCE: 'crash:balance',
  ALERT: 'crash:alert',
  DISABLED: 'crash:disabled'
}

// Имена событий клиент → сервер
export const CLIENT_EVENTS = {
  PLACE_BET: 'crash:place-bet',
  CASHOUT: 'crash:cashout'
}

// Фазы раунда на клиенте
export const PHASES = {
  IDLE: 'idle',         // до первого снапшота
  BETTING: 'betting',   // приём ставок (crash:round … crash:run)
  RUNNING: 'running',   // множитель растёт (crash:run … crash:bust)
  BUSTED: 'busted'      // крах + пауза до следующего раунда
  // «Режим выключен» — не фаза, а флаг isDisabled в store: раунд доигрывается до конца
}

// REST-эндпоинты истории (§9a)
export const CRASH_API = {
  INVENTORY: '/api/crash/inventory/',
  HISTORY: '/api/crash/history/',
  HISTORY_ME: '/api/crash/history/me/',
  // :uid подставляется в коде
  ROUND: (uid) => `/api/crash/history/${uid}/`
}
